import { faEmptySet, faSliders } from '@fortawesome/pro-light-svg-icons';
import { faFlag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, IconButton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { GanttFilter, useGanttFilterStore } from '../../hooks/useGanttFilterStore';
import { useGanttInstanceId } from '../../Gantt/utils';

export const GanttFilterButton = () => {
  const instanceId = useGanttInstanceId();
  const { t, tWrapper } = useCustomTranslation('products.productionPlan.kanban');
  const filters = useGanttFilterStore((state) => state.ganttFilters);
  const setGanttFilters = useGanttFilterStore((state) => state.setGanttFilters);

  const handleSelectOption = (option: GanttFilter) => (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if (filters.includes(option)) {
      setGanttFilters(
        instanceId,
        filters.filter((o) => o !== option),
      );
    } else {
      setGanttFilters(instanceId, [...filters, option]);
    }
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton
          count={filters.length}
          Icon={<FontAwesomeIcon icon={faSliders} />}
          withIndicator={filters.length > 0}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="z-25 pt-2">
        <div className="mb-2 ml-4 text-s11-sb text-text-secondary uppercase">{t('common.filterView')}</div>

        <DropdownMenu.Checkbox
          checked={filters.includes(GanttFilter.PRIORITY)}
          onSelect={handleSelectOption(GanttFilter.PRIORITY)}
        >
          <FontAwesomeIcon className="size-5! text-icon-brand" icon={faFlag} />
          {tWrapper('priority')}
        </DropdownMenu.Checkbox>
        <DropdownMenu.Checkbox
          checked={filters.includes(GanttFilter.SHOW_WITHOUT_TASKS)}
          onSelect={handleSelectOption(GanttFilter.SHOW_WITHOUT_TASKS)}
        >
          <FontAwesomeIcon className="size-5! text-icon-primary" icon={faEmptySet} />
          {tWrapper('showWithoutTasks')}
        </DropdownMenu.Checkbox>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
